var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGridViewIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 25.527,
    id: "Layer_1",
    viewBox: "0 0 25.945 25.527",
    width: 25.945,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs193"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid-2",
    transform: "translate(-2.923,-3.237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10.246,4.228 c 0,-0.547 -0.443,-0.991 -0.99,-0.991 H 3.914 C 3.366,3.237 2.923,3.68 2.923,4.228 V 9.57 c 0,0.546 0.443,0.99 0.991,0.99 h 5.342 c 0.547,0 0.99,-0.444 0.99,-0.99 z",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.453,4.228 c 0,-0.547 -0.443,-0.991 -0.991,-0.991 h -5.343 c -0.546,0 -0.99,0.443 -0.99,0.991 V 9.57 c 0,0.546 0.444,0.99 0.99,0.99 h 5.343 c 0.548,0 0.991,-0.444 0.991,-0.99 z",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.868,4.228 c 0,-0.547 -0.443,-0.991 -0.99,-0.991 h -5.342 c -0.548,0 -0.991,0.443 -0.991,0.991 V 9.57 c 0,0.546 0.443,0.99 0.991,0.99 h 5.342 c 0.547,0 0.99,-0.444 0.99,-0.99 z",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.246,13.224 c 0,-0.547 -0.443,-0.99 -0.99,-0.99 H 3.914 c -0.548,0 -0.991,0.443 -0.991,0.99 v 5.342 c 0,0.549 0.443,0.99 0.991,0.99 h 5.342 c 0.547,0 0.99,-0.441 0.99,-0.99 z",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.453,13.224 c 0,-0.547 -0.443,-0.99 -0.991,-0.99 h -5.343 c -0.546,0 -0.99,0.443 -0.99,0.99 v 5.342 c 0,0.549 0.444,0.99 0.99,0.99 h 5.343 c 0.548,0 0.991,-0.441 0.991,-0.99 z",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.868,13.224 c 0,-0.547 -0.443,-0.99 -0.99,-0.99 h -5.342 c -0.548,0 -0.991,0.443 -0.991,0.99 v 5.342 c 0,0.549 0.443,0.99 0.991,0.99 h 5.342 c 0.547,0 0.99,-0.441 0.99,-0.99 z",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.246,22.43 c 0,-0.545 -0.443,-0.99 -0.99,-0.99 H 3.914 c -0.548,0 -0.991,0.445 -0.991,0.99 v 5.344 c 0,0.547 0.443,0.99 0.991,0.99 h 5.342 c 0.547,0 0.99,-0.443 0.99,-0.99 z",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.453,22.43 c 0,-0.545 -0.443,-0.99 -0.991,-0.99 h -5.343 c -0.546,0 -0.99,0.445 -0.99,0.99 v 5.344 c 0,0.547 0.444,0.99 0.99,0.99 h 5.343 c 0.548,0 0.991,-0.443 0.991,-0.99 z",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.868,22.43 c 0,-0.545 -0.443,-0.99 -0.99,-0.99 h -5.342 c -0.548,0 -0.991,0.445 -0.991,0.99 v 5.344 c 0,0.547 0.443,0.99 0.991,0.99 h 5.342 c 0.547,0 0.99,-0.443 0.99,-0.99 z",
    id: "path187"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGridViewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grid-view-icon.9fded2f8e30e8fd7c9f2458aa3d50b5c.svg";